import { Flex } from "../components/Flex";
import { Box } from "../components/Box";
import { Image } from "../components/Image";
import { H1 } from "../components/Heading";
import { Paragraph } from "../components/Paragraph";
import { Button } from "../components/Button";
import tillerVerifySvg from "../assets/verify-tiller.svg";
import serverError from "../assets/server-error.svg";
import { Link } from "react-router-dom";
import { ROUTE } from "../routes";

const ServiceUnavailablePage = () => {
  return (
    <Flex height="100vh">
      <Flex
        width="900px"
        justifyContent="space-between"
        flexDirection="column"
        p="60px"
      >
        <Image
          src={tillerVerifySvg}
          alt="tiller verify logo"
          height="80px"
          width="100px"
        />
        <Box>
          <H1 color="darkBlue">
            We apologise, but the service you're trying to reach is currently unavailable.
          </H1>
          <Link to={ROUTE.ROOT}>
            <Button size="large" width="100%" mt="4">
              Retry
            </Button>    
          </Link>
        </Box>
        <Box />
      </Flex>
      <Flex
        bg={"background"}
        height="100vh"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
        pt="5"
      >
        <Box width="55%">
          <H1 color="darkBlue">Service Unavailable</H1>
          <Paragraph color="gray.50" fontSize="3">
            The service is currently unavailable, Please try again later
          </Paragraph>
        </Box>
        <Image src={serverError} alt="folder" display="block" maxWidth="60%" />
      </Flex>
    </Flex>
  );
};

export default ServiceUnavailablePage;
